import { render, staticRenderFns } from "./TradingBetweenCountry.vue?vue&type=template&id=60227de1&"
import script from "./TradingBetweenCountry.vue?vue&type=script&lang=js&"
export * from "./TradingBetweenCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports